export default __webpack_public_path__ + "static/media/icon_search.471f2192.png";